module.exports = __webpack_public_path__ + "static/media/14UNEP24.c4a32fa9.jpg";